var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.stepLoading,
          expression: "stepLoading",
        },
      ],
      staticClass: "step_content",
    },
    [
      _c(
        "div",
        { staticClass: "operation_wrapper" },
        [
          _c("span", { staticClass: "step_icon border_leftT" }),
          _c("span", { staticClass: "step_icon border_rightT" }),
          _c("span", { staticClass: "step_icon border_leftB" }),
          _c("span", { staticClass: "step_icon border_rightB" }),
          _c("h3", { staticClass: "task-name-info" }, [
            _vm._v("任务名称："),
            _c("span", [_vm._v(_vm._s(_vm.taskName))]),
          ]),
          _c(
            "div",
            { staticClass: "extract_opt_wrapper" },
            [
              _c("span", { staticClass: "step_opt_title" }, [
                _vm._v("抽取项目"),
              ]),
              _c("span", { staticClass: "step_opt_icon border_opt_leftT" }),
              _c("span", { staticClass: "step_opt_icon border_opt_rightT" }),
              _c("span", { staticClass: "step_opt_icon border_opt_leftB" }),
              _c("span", { staticClass: "step_opt_icon border_opt_rightB" }),
              _c(
                "span",
                { staticClass: "extract_info extract_info_left" },
                [
                  _vm._v("进入抽取的项目共有："),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          _vm.extractPondListDialog = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.total))]
                  ),
                  _vm._v(" 个"),
                ],
                1
              ),
              _c(
                "span",
                { staticClass: "extract_info extract_info_right" },
                [
                  _vm._v("本次将抽取："),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          _vm.extractFilterDialog = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.extractNum))]
                  ),
                  _vm._v(" 个"),
                ],
                1
              ),
              _c(
                "el-scrollbar",
                { style: { height: _vm.cardMinHeight, "min-height": "150px" } },
                [
                  _vm.extractIngFlag
                    ? _c(
                        "el-row",
                        _vm._l(_vm.extractNum, function (i) {
                          return _c(
                            "el-col",
                            {
                              key: i,
                              staticStyle: { padding: "10px" },
                              attrs: {
                                span: _vm.extractNum == 1 ? 18 : 12,
                                offset: _vm.extractNum == 1 ? 3 : 0,
                              },
                            },
                            [
                              _c(
                                "vue-seamless-scroll",
                                {
                                  staticClass: "seamless-warp",
                                  attrs: {
                                    data: _vm.defaultExtractPondListShuffle,
                                    "class-option": _vm.classOption,
                                  },
                                },
                                _vm._l(
                                  _vm.defaultExtractPondListShuffle,
                                  function (item, index) {
                                    return _c("p", { key: index }, [
                                      _vm._v(_vm._s(item.projectName)),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  !_vm.extractIngFlag
                    ? _c(
                        "el-row",
                        _vm._l(_vm.extractResultList, function (item, index) {
                          return _c(
                            "el-col",
                            {
                              key: index,
                              staticStyle: { padding: "10px" },
                              attrs: {
                                span: _vm.extractNum == 1 ? 18 : 12,
                                offset: _vm.extractNum == 1 ? 3 : 0,
                              },
                            },
                            [
                              _c("div", { staticClass: "seamless-warp" }, [
                                _c("p", [_vm._v(_vm._s(item.projectName))]),
                              ]),
                            ]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("br"),
          !_vm.extractIngFlag
            ? _c(
                "el-button",
                {
                  staticClass: "start-extract-btn",
                  attrs: {
                    type: "primary",
                    plain: "",
                    disabled: _vm.historyid != -1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.startExtract()
                    },
                  },
                },
                [_vm._v("开始抽取")]
              )
            : _vm._e(),
          _vm.extractIngFlag
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.getExtractResult(true)
                    },
                  },
                },
                [_vm._v("停止")]
              )
            : _vm._e(),
          _c("br"),
          _c("span"),
          _c(
            "el-button",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "text", disabled: _vm.historyid == -1 },
              on: {
                click: function ($event) {
                  return _vm.showExtractResult(true)
                },
              },
            },
            [_vm._v("查看抽取结果")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "btn_wraper" },
        [
          _c("p", { staticClass: "supervisionNameInfo" }, [
            _vm._v("监督检查单位：" + _vm._s(_vm.supervisionIdsName)),
          ]),
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                "popper-class": "bigScreenPopper",
                "visible-arrow": false,
                effect: "light",
                placement: "top-start",
              },
            },
            [
              _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                _vm._v(" " + _vm._s(_vm.supervisionIdsName) + " "),
              ]),
              _c(
                "el-button",
                { staticStyle: { float: "right" }, attrs: { type: "text" } },
                [_vm._v(" 更多> ")]
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.extractIngFlag, plain: "" },
              on: {
                click: function ($event) {
                  return _vm.prevStep()
                },
              },
            },
            [_vm._v("上一步")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                disabled: _vm.historyid == -1,
                plain: "",
              },
              on: {
                click: function ($event) {
                  return _vm.nextStep()
                },
              },
            },
            [_vm._v("下一步")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "80%",
            title: "本次随机抽取数量为：" + _vm.extractResultList.length + "个",
            visible: _vm.extractResultListDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.extractResultListDialog = $event
            },
          },
        },
        [
          [
            _c(
              "el-table",
              {
                staticClass: "bigScreenTable",
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  stripe: "",
                  data: _vm.extractResultList,
                  height: _vm.tableMaxHeight,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    "header-align": "center",
                    label: "序号",
                    width: "80",
                    type: "index",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "projectName",
                    label: "项目名称",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "contractSignTime",
                    label: "合同签署时间",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(
                                  scope.row.contractSignTime,
                                  "yyyy-MM-dd HH:mm:ss"
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "projectTypeName",
                    label: "招标项目类型",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                }),
              ],
              1
            ),
          ],
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.extractResultListDialog = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "80%",
            title: "符合当前抽取条件的总数量为" + _vm.total + "个",
            visible: _vm.extractPondListDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.extractPondListDialog = $event
            },
          },
        },
        [
          [
            _c(
              "el-table",
              {
                staticClass: "bigScreenTable",
                staticStyle: { width: "100%" },
                attrs: {
                  border: "",
                  data: _vm.extractPondList,
                  height: _vm.tableMaxHeight,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    "header-align": "center",
                    label: "序号",
                    width: "80",
                    type: "index",
                    index: _vm.getRowsIndex,
                    align: "center",
                  },
                }),
                _vm.historyid == -1
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "projectName",
                        label: "项目名称",
                        "show-overflow-tooltip": true,
                        align: "center",
                      },
                    })
                  : _vm._e(),
                _vm.historyid != -1
                  ? _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": true,
                        align: "center",
                        label: "项目名称",
                        prop: "projectNameVisible",
                      },
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: {
                    prop: "contractSignTime",
                    label: "合同签署时间",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.formatDate(
                                  scope.row.contractSignTime,
                                  "yyyy-MM-dd HH:mm:ss"
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "projectTypeName",
                    label: "招标项目类型",
                    "show-overflow-tooltip": true,
                    align: "center",
                  },
                }),
              ],
              1
            ),
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next",
                "page-sizes": [10, 20, 50, 100],
                "popper-class": "bigScreenSelectPopper",
                "page-size": _vm.pageSize,
                total: _vm.total,
                "current-page": _vm.pageIndex,
              },
              on: {
                "size-change": _vm.sizeChangeHandle,
                "current-change": _vm.currentChangeHandle,
              },
            }),
          ],
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.extractPondListDialog = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "抽取条件", visible: _vm.extractFilterDialog },
          on: {
            "update:visible": function ($event) {
              _vm.extractFilterDialog = $event
            },
          },
        },
        [
          [
            _vm.form.ruleType == 1 || _vm.form.ruleType == 2
              ? _c("p", { staticClass: "extractFilterWrapper" }, [
                  _vm._v(" 项目抽取条件：从符合条件的总数中随机抽取 "),
                  _c("span", [_vm._v(_vm._s(_vm.form.extractRule))]),
                  _c("span", [
                    _vm._v(_vm._s(_vm.form.ruleType == 1 ? "个" : "%") + " 。"),
                  ]),
                ])
              : _vm._e(),
            _vm.form.ruleType == 3
              ? _c(
                  "div",
                  {
                    staticClass: "extractFilterWrapper",
                    staticStyle: { display: "flex" },
                  },
                  [
                    _c("span", { staticStyle: { "vertical-align": "top" } }, [
                      _vm._v("项目抽取条件："),
                    ]),
                    _c(
                      "table",
                      {
                        staticClass: "role_table",
                        staticStyle: { width: "calc(100% - 120px)" },
                      },
                      [
                        _c("thead", { staticStyle: { width: "100%" } }, [
                          _c("th", { attrs: { width: "50%" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatterDataDictionary(
                                    _vm.extractNumberTypeList,
                                    _vm.form.ruleCompMethod
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("th", { attrs: { width: "50%" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.form.numOrPercentType == "1"
                                    ? "数量"
                                    : "比例"
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.ruleList, function (item, index) {
                            return _c("tr", { key: index }, [
                              _c("td", [
                                _vm.form.ruleCompMethod == "1"
                                  ? _c("p", [
                                      _c("span", [
                                        _vm._v(_vm._s(item.projectTypeName)),
                                      ]),
                                    ])
                                  : _vm.form.ruleCompMethod == "2"
                                  ? _c("p", [
                                      _vm._v(" 介于 "),
                                      _c("span", [
                                        _vm._v(_vm._s(item.currencyMin)),
                                      ]),
                                      _vm._v("万元 至 "),
                                      _c("span", [
                                        _vm._v(_vm._s(item.currencyMax)),
                                      ]),
                                      _vm._v(" 万元 "),
                                    ])
                                  : _c("p", [
                                      _c("span", [
                                        _vm._v(_vm._s(item.regionCodeName)),
                                      ]),
                                    ]),
                              ]),
                              _c("td", [
                                _vm._v(" 符合抽取条件总项目的 "),
                                _c("span", [_vm._v(_vm._s(item.numOrPercent))]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.form.numOrPercentType == "1"
                                        ? "个"
                                        : "%"
                                    )
                                  ),
                                ]),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.extractFilterDialog = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }